import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import DormakabaSection from './DormakabaSection'
import SaltoSpaceSection from './SaltoSpaceSection'
import RemoteLockSection from './RemoteLockSection'
import SwiftlaneSection from './SwiftlaneSection'
import PointCentralSection from './PointCentralSection'
import IglooWorkSection from './IglooWorkSection'
import AssaAbloyVisionLineSection from './AssaAbloyVisionLineSection'

// Note: building 805 has Salto Space enabled without the saltoSpaceAvailable flag set on the building
// TODO: remove once building 805 has saltoSpaceAvailable corrected in the database
const SALTO_SPACE_ALWAYS_AVAILABLE_BUILDING_IDS = [805]

const IntegrationsSection = ({ isSubmitting, clientData, onClientDataChange }) => {
  const { t } = useTranslation(['clients-legacy'])
  const {
    buildingId: {
      id: buildingId,
      saltoSpaceAvailable,
      saltoSpaceFobsAvailable,
      dormakabaAvailable: isDormakabaAvailable,
      remoteLockAvailable: isRemoteLockAvailable,
      remoteLockFobAvailable: isRemoteLockFobAvailable,
      swiftlaneAvailable: isSwiftlaneAvailable,
      pointCentralAvailable: isPointCentralAvailable,
      iglooWorkAvailable: isIglooWorkAvailable,
      visionlineAvailable: isAssaAbloyVisionLineAvailable,
    },
  } = clientData

  const isSaltoSpaceAvailable =
    saltoSpaceAvailable || SALTO_SPACE_ALWAYS_AVAILABLE_BUILDING_IDS.includes(buildingId)

  if (!clientData) return null
  return (
    <div className="integrations">
      <div className="title">{t('clients-legacy:profileView.integrations.title')}</div>
      <DormakabaSection
        isAvailable={isDormakabaAvailable}
        isSubmitting={isSubmitting}
        buildingId={buildingId}
        clientId={clientData.id}
        clientEmail={clientData.user?.email}
        apartment={clientData.apartment}
      />
      <RemoteLockSection
        isAvailable={isRemoteLockAvailable}
        isFobAvailable={isRemoteLockFobAvailable}
        isIntegratedId={clientData.remoteLockId || null}
        buildingId={buildingId}
        clientId={clientData.id}
        userId={clientData.user.id}
      />
      <SaltoSpaceSection
        isAvailable={isSaltoSpaceAvailable}
        isFobsAvailable={saltoSpaceFobsAvailable}
        buildingId={buildingId}
        clientData={clientData}
        onClientDataChange={onClientDataChange}
      />
      <PointCentralSection
        isAvailable={!!isPointCentralAvailable}
        buildingId={buildingId}
        clientId={clientData.id}
      />
      <SwiftlaneSection
        isAvailable={isSwiftlaneAvailable}
        buildingId={buildingId}
        clientData={clientData}
      />
      <IglooWorkSection
        isAvailable={isIglooWorkAvailable}
        buildingId={buildingId}
        clientId={clientData.id}
        clientData={clientData}
      />
      <AssaAbloyVisionLineSection
        isAvailable={isAssaAbloyVisionLineAvailable}
        buildingId={buildingId}
        clientId={clientData.id}
        apartment={clientData.apartment}
      />
    </div>
  )
}

IntegrationsSection.propTypes = {
  isSubmitting: PropTypes.bool,
  clientData: PropTypes.object,
  onClientDataChange: PropTypes.func,
}

export default IntegrationsSection
